export default {
    topics: [
        {
            title: ' DeleteWebApp ',
            href: 'sm-webApp-DeleteWebApp.html',
            attributes: { 'data-id': 'sm-webApp-DeleteWebApp' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-DeleteWebApp-d66e4144',
            topics: [],
        },
        {
            title: ' DictionaryCheck ',
            href: 'sm-webApp-DictionaryCheck.html',
            attributes: { 'data-id': 'sm-webApp-DictionaryCheck' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-DictionaryCheck-d66e4152',
            topics: [],
        },
        {
            title: ' DictionaryExport ',
            href: 'sm-webApp-DictionaryExport.html',
            attributes: { 'data-id': 'sm-webApp-DictionaryExport' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-DictionaryExport-d66e4160',
            topics: [],
        },
        {
            title: ' DictionaryImport ',
            href: 'sm-webApp-DictionaryImport.html',
            attributes: { 'data-id': 'sm-webApp-DictionaryImport' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-DictionaryImport-d66e4168',
            topics: [],
        },
        {
            title: ' GenerateSchema ',
            href: 'sm-webApp-GenerateSchema.html',
            attributes: { 'data-id': 'sm-webApp-GenerateSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-GenerateSchema-d66e4176',
            topics: [],
        },
        {
            title: ' GetUsedLanguagesEnum ',
            href: 'sm-webApp-GetUsedLanguagesEnum.html',
            attributes: { 'data-id': 'sm-webApp-GetUsedLanguagesEnum' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-GetUsedLanguagesEnum-d66e4184',
            topics: [],
        },
        {
            title: ' InvalidateWebAppCache ',
            href: 'sm-webApp-InvalidateWebAppCache.html',
            attributes: { 'data-id': 'sm-webApp-InvalidateWebAppCache' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-InvalidateWebAppCache-d66e4192',
            topics: [],
        },
        {
            title: ' NormalizeField ',
            href: 'sm-webApp-NormalizeField.html',
            attributes: { 'data-id': 'sm-webApp-NormalizeField' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-NormalizeField-d66e4200',
            topics: [],
        },
        {
            title: ' Publish ',
            href: 'sm-webApp-Publish.html',
            attributes: { 'data-id': 'sm-webApp-Publish' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-Publish-d66e4208',
            topics: [],
        },
        {
            title: ' RemoveLog ',
            href: 'sm-webApp-RemoveLog.html',
            attributes: { 'data-id': 'sm-webApp-RemoveLog' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-RemoveLog-d66e4216',
            topics: [],
        },
        {
            title: ' RemoveUnusedField ',
            href: 'sm-webApp-RemoveUnusedField.html',
            attributes: { 'data-id': 'sm-webApp-RemoveUnusedField' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-RemoveUnusedField-d66e4225',
            topics: [],
        },
        {
            title: ' ScanResources ',
            href: 'sm-webApp-ScanResources.html',
            attributes: { 'data-id': 'sm-webApp-ScanResources' },
            menu: { hasChildren: false },
            tocID: 'sm-webApp-ScanResources-d66e4233',
            topics: [],
        },
    ],
};

